import StarterForm from './StarterForm'
import './starter-form.css'
import './starter-form-ghosting.css'

export default StarterForm
